// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".promotion-card .card__inner-content{width:38rem;margin:0 auto}@media screen and (min-width:48em){.promotion-card .promotion-card__links ul{display:block;margin:0 auto}}@supports (display:grid){.promotion-card .promotion-card__links ul{text-align:left}@media screen and (min-width:48em){.promotion-card .promotion-card__links ul{display:grid;grid-template-columns:auto auto;grid-column-gap:.5rem}}}", ""]);
// Exports
module.exports = exports;
